import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-chubb-footer',
    imports: [],
    templateUrl: './chubb-footer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './chubb-footer.component.scss'
})
export class ChubbFooterComponent implements OnInit {

  year = 0;
  constructor() { }

  ngOnInit() {
    this.year = new Date().getFullYear();
  }

}
